import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./component/header/navbar";
import Home from "./pages/home"
import Services from "./pages/services";
import Blog from './pages/blog'
import About from "./pages/about"
import Join from "./pages/join"
import Footer from "./component/footer/footer";
import "./i18"
import i18n from "./i18";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function App() {
  useEffect(() => {
  AOS.init({
    duration: 2000,
    once: true,
    easing: "ease-in-out",
  });
}, []);

 
  return (
    <BrowserRouter>
    <Navbar/>
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/join" element={<Join />} />
        <Route path="/services" element={<Services />} />

      </Routes>
      <Footer/>
    </BrowserRouter>
    
  );
}

export default App;
